<template>
  <div style="margin-top: -12px">
    <v-container fluid>
      <v-card flat class="disable-scrollbars">
        <v-card-text>
          <div style="clear: both"></div>
          <template>
            <v-data-table
              :headers="headers"
              :items-per-page="5"
              :hide-default-footer="footeHiden"
              :disable-pagination="paginat"
              loading-text="A carregar"
              :items="getInvoiceOpenInStore"
            >
              <template v-slot:item.invoiceUUID="{ item }">
                <v-chip
                  :color="getColor('Transferir')"
                  @click="printInvoice(item.invoiceUUID)"
                  dark
                  outlined
                  label
                  style="width: 105px"
                >
                  <v-icon left size="16">{{ getIcon("Transferir") }}</v-icon>
                  <span>Transferir</span>
                </v-chip>
              </template>
              <template v-slot:item.totalAmount="{ item }">
                <span :style="getColorMount(item.totalAmount)">
                  {{ new Intl.NumberFormat("de-DE").format(item.totalAmount) }}
                  {{ currency }}
                </span>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="getColorStatus(item.status)"
                  dark
                  label
                  style="width: 80px"
                >
                  <span>Aberto</span>
                </v-chip>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapHelperEnterprise } from "@/store/helperEnterprise";

export default {
  name: "MonthHistoric",
  data() {
    return {
      paginat: false,
      footeHiden: false,
      currency: "Akz",
      headers: [
        {
          text: "PERÍODO",
          align: "start",
          sortable: false,
          value: "period"
        },
        { text: "REFERÊNCIA DA FACTURA", value: "invoiceRef" },
        { text: "MONTANTE", value: "totalAmount" },
        { text: "ESTADO", value: "status", sortable: false },
        { text: "TRANSFERIR", value: "invoiceUUID", sortable: false }
      ]
    };
  },
  methods: {
    getColor(type) {
      if (type === "Transferir") return "green";
    },
    getIcon(type) {
      if (type === "Transferir") return "mdi-download";
    },
    getColorMount(type) {
      if (type > 30000) return "color:green";
      else return "color:#1976d2c4";
    },
    getColorStatus(type) {
      if (type === "Aberto") {
        return "red";
      } else if (type === "Fechada") {
        return "green";
      } else return "red";
    },
    printInvoice(type) {
      return this.$store.dispatch("printInvoice", type);
    }
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
